export default "__VITE_ASSET__v9lv2q05__"